export const isCreditsCard = card => card.type === 'credits';
export const isProductCard = card => card.type === 'product';
export const isCouponCard = card => card.type === 'coupon';

export const cardAlreadyFlipped = (card, cardsFlipped = {}) =>
    cardsFlipped && cardsFlipped.hasOwnProperty(card?.id);

export const cardWin = (card, cardsFlipped = {}) =>
    Boolean(cardAlreadyFlipped(card, cardsFlipped) && cardsFlipped[card.id].result);

export const cardLoss = (card, cardsFlipped = {}) =>
    Boolean(cardAlreadyFlipped(card, cardsFlipped) && !cardsFlipped[card.id].result);

export const getCardWinContent = card =>
    isCreditsCard(card) ? `${card.amount} Credits` : 'einen Preis';
